import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
export function ThankYou() {
  return <main className="bg-deal-black min-h-screen flex flex-col items-center px-6 py-12" data-id="element-851">
      {/* Progress Bar */}
      <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="flex flex-col items-center mb-10" data-id="element-852">
        <div className="flex items-center gap-0" data-id="element-853">
          {[0, 1, 2, 3, 4].map(i => <Fragment key={i} data-id="element-854">
              {i > 0 && <div className={`w-16 md:w-24 h-0.5 ${i <= 3 ? 'bg-deal-green' : 'bg-white/20'}`} data-id="element-855" />}
              <div className={`w-4 h-4 rounded-full flex-shrink-0 ${i <= 3 ? 'bg-deal-green' : 'border-2 border-white/20 bg-transparent'}`} data-id="element-856" />
            </Fragment>)}
        </div>
        <p className="text-white/40 text-xs mt-2 tracking-wide" data-id="element-857">96% Complete</p>
      </motion.div>

      {/* Logo */}
      <motion.img initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} src="https://cdn.magicpatterns.com/uploads/vdgv36ytuJeDtCVoSnd1Nw/DF_logo_.png" alt="Deal Flow" className="h-10 md:h-12 mb-8" data-id="element-858" />

      {/* Heading */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.2
    }} className="text-center mb-12" data-id="element-859">
        <p className="text-deal-green text-sm font-semibold tracking-wide mb-2" data-id="element-860">
          You're Almost There
        </p>
        <h1 className="text-2xl md:text-3xl font-bold text-white" data-id="element-861">
          Last step. Confirm Your Appointment.
        </h1>
      </motion.div>

      {/* Steps Container */}
      <div className="w-full max-w-xl space-y-12" data-id="element-862">
        {/* Step 1 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-center" data-id="element-863">
          <h2 className="text-lg md:text-xl font-bold text-white mb-1" data-id="element-864">
            <span className="text-deal-green" data-id="element-865">Step 1:</span> Check your email &
            accept the calendar invite
          </h2>

          {/* Mock Calendar Invite Card */}
          <div className="mt-6 bg-white rounded-lg shadow-xl overflow-hidden text-left mx-auto max-w-md" data-id="element-866">
            <div className="flex items-start gap-4 p-4" data-id="element-867">
              {/* Calendar Icon */}
              <div className="flex-shrink-0 bg-blue-500 rounded-lg w-12 h-14 flex flex-col items-center justify-center text-white" data-id="element-868">
                <span className="text-[9px] uppercase font-bold leading-none tracking-wider" data-id="element-869">
                  APR
                </span>
                <span className="text-xl font-bold leading-none mt-0.5" data-id="element-870">
                  22
                </span>
              </div>
              {/* Details */}
              <div className="flex-1 min-w-0" data-id="element-871">
                <p className="text-gray-900 font-semibold text-sm" data-id="element-872">
                  Your Consultation with Deal Flow
                </p>
                <p className="text-gray-500 text-xs mt-0.5" data-id="element-873">
                  Invite to discuss candidacy
                </p>
                <div className="mt-2 space-y-0.5" data-id="element-874">
                  <p className="text-gray-500 text-xs" data-id="element-875">
                    <span className="text-gray-400 font-medium" data-id="element-876">When:</span> Wed
                    Apr 22, 2026 — 30 min
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-877">
                    <span className="text-gray-400 font-medium" data-id="element-878">Who:</span> Deal
                    Flow Advisory Team
                  </p>
                </div>
                {/* RSVP Buttons */}
                <div className="flex gap-2 mt-3" data-id="element-879">
                  <button className="px-3 py-1 bg-deal-green text-white text-xs font-semibold rounded" data-id="element-880">
                    Yes
                  </button>
                  <button className="px-3 py-1 bg-gray-100 text-gray-500 text-xs font-medium rounded border border-gray-200" data-id="element-881">
                    Maybe
                  </button>
                  <button className="px-3 py-1 bg-gray-100 text-gray-500 text-xs font-medium rounded border border-gray-200" data-id="element-882">
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Step 2 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.45
      }} className="text-center" data-id="element-883">
          <h2 className="text-lg md:text-xl font-bold text-white mb-1" data-id="element-884">
            <span className="text-deal-green" data-id="element-885">Step 2:</span> Reply to confirm
            your appointment.
          </h2>
          <p className="text-white/50 text-xs leading-relaxed mt-2 max-w-md mx-auto" data-id="element-886">
            Our team will send a brief message to confirm your contact details.
            Please reply to verify we have the correct information. No
            confirmation. No call.
          </p>

          {/* Mock Email Card */}
          <div className="mt-6 bg-white rounded-lg shadow-xl overflow-hidden text-left mx-auto max-w-md" data-id="element-887">
            <div className="p-5" data-id="element-888">
              <p className="text-gray-900 font-semibold text-sm mb-0.5" data-id="element-889">
                Your Deal Flow Consultation is Confirmed
              </p>
              <p className="text-gray-400 text-[10px] mb-4" data-id="element-890">
                Deal Flow Advisory · team@getdealflow.ai
              </p>

              <div className="space-y-3 text-gray-600 text-xs leading-relaxed" data-id="element-891">
                <p data-id="element-892">Hi [First Name],</p>
                <p data-id="element-893">
                  This is a quick note from the Deal Flow team. We're looking
                  forward to our scheduled conversation.
                </p>
                <p data-id="element-894">
                  To confirm your spot, please reply{' '}
                  <span className="font-bold text-gray-900" data-id="element-895">"YES"</span> to this
                  message. This ensures your time slot is secured and our team
                  is prepared for your call.
                </p>
                <p data-id="element-896">
                  If we don't receive a confirmation, we may need to reallocate
                  your time to another founder.
                </p>
                <p data-id="element-897">Talk soon,</p>
                <p className="font-semibold text-gray-800" data-id="element-898">
                  The Deal Flow Team
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </main>;
}